import React from 'react';
import { useSearchDetails } from 'v2/queries/searches/useSearchDetails';

type ActivityItemLinkCreatedDescriptionProps = {
  entityName: string;
  searchID: number;
};

export function ActivityItemLinkCreatedDescription({
  entityName,
  searchID,
}: ActivityItemLinkCreatedDescriptionProps) {
  const { data: search } = useSearchDetails(searchID);

  if (search === undefined) {
    return (
      <p className="text-light4">
        <span className="text-primary">{entityName}</span> was linked to a
        request.
      </p>
    );
  }

  return (
    <p className="text-light4">
      <span className="text-primary">{entityName}</span> has been linked to
      request <span className="text-primary">{search?.name}</span>.
    </p>
  );
}
